var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',{class:['dialog', {hiding: _vm.hiding}]},[_c('div',{staticClass:"content"},[_c('header',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._t("default")],2),_c('div',{staticClass:"close"},[_c('i',{on:{"click":_vm.close}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }